/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import OverviewBody from '../super-admin/overview/overview/OverviewBody';
import VpFseNavBar from '../../../layouts/vp-fse/VpFseNavBar';

const VpFseOverview = () => {
    const firstName = sessionStorage.getItem('firstName');


  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <VpFseNavBar currentPage="Overview" position={firstName} />
        <OverviewBody />
      </main>
    </div>
  );
};

export default VpFseOverview;
